/**
 * Check if a file exists at a URL.
 *
 * Sends a HTTP HEAD request to the url and checks the status code to determine
 * if the requested location contains a file.
 *
 * @param {string} url - The URL of the file to check.
 * @return {Promise<boolean>} True if a file exists at the url, false otherwise.
 */
export async function fileExists(url?: string): Promise<boolean> {
  try {
    if (!url) return false;
    const response = await fetch(url, { method: 'HEAD' });
    return response.ok;
  } catch (error) {
    return false;
  }
}
